import { resources_EN, resources_FR } from '@configs/i18n/languages';

export const globalResources = {
    en: resources_EN,
    fr: resources_FR,
};

export const resourceNamespaces = Object.keys(resources_EN);
